module.exports = __webpack_public_path__ + "img/fossil2Img3.cbe8670c.jpg";